
import React from 'react';
import { Link } from 'react-router-dom';
import { LogOutIcon } from 'lucide-react';
import { PopoverContent } from '@/components/ui/popover';
import { Button } from '@/components/ui/button';
import { useAuth } from '@/contexts/auth/useAuth';

const UserProfileMenu = () => {
  const { user, logout } = useAuth();

  return (
    <PopoverContent className="w-56 p-4">
      <div className="space-y-3">
        <div className="font-medium">
          {user?.name || 'User'}
        </div>
        <div className="text-sm text-muted-foreground">
          {user?.email}
        </div>
        <div className="pt-2">
          <Button variant="outline" size="sm" asChild className="w-full">
            <Link to="/profile">My Profile</Link>
          </Button>
        </div>
        <Button 
          variant="ghost" 
          size="sm" 
          className="w-full flex items-center justify-start text-destructive" 
          onClick={logout}
        >
          <LogOutIcon className="mr-2 h-4 w-4" />
          Sign Out
        </Button>
      </div>
    </PopoverContent>
  );
};

export default UserProfileMenu;
